import defaultProfileIcon from "../../../assets/icons/default-profile.jpg";

const ProfileHeader = ({ username, profileAvatar, onEditAvatar }) => (
    <div className="profile-card-header">
        <div className="avatar-flip">
            <img 
                onClick={onEditAvatar}
                src={profileAvatar ? profileAvatar : defaultProfileIcon}
                height="150" 
                width="150" 
                alt="profile-icon" 
                className="pointer"
            />
        </div>
        <h2>{username}</h2>
    </div>
);

export default ProfileHeader;
